const initialState = {
  obfuscatedData: {
    email: '',
    isLoading: false
  },

};

export function reinvite(state = initialState, action) {
  switch (action.type) {
  case 'REINVITE_OBFUSCATED_EMAIL_REQUEST':
    return Object.assign({}, state, {obfuscatedData: Object.assign(state.obfuscatedData, {isLoading: true})});
  case 'REINVITE_OBFUSCATED_EMAIL_RECEIVE':
    return Object.assign({}, state, {obfuscatedData: Object.assign(state.obfuscatedData, {isLoading: false, email: action.payload.invitee })});
  case 'REINVITE_REQUEST':
    return Object.assign({}, state, {isReinviting: true});
  case 'REINVITE_RECEIVE':
    return Object.assign({}, state, {isReinviting: false});
  default:
    return state;
  }
}
